module.exports = __webpack_public_path__ + "media/images/landing/home/recognition-457a43b50ffd9c5c95ef34a2603bf7a8.png";